
// Converts to radians for PixiJs rotation values
export const radians = (degrees: number) => {
    return degrees * (Math.PI / 180);
};

// Plays affect on Pixi Sprite
export const play = (
    start: number,
    end: number,
    current: number,
    effect: (value: number) => void,
    from: number,
    to: number,
) => {
    if (end < start) {
        throw new Error('Animation end is before start');
    }
    if (current < start) { return; }
    if (current > end) { return; }

    const progress = Math.max(Math.min((
        (current - start) / (end - start)
    ), 1), 0);
    const value = from + ((to - from) * progress);
  
    effect(value);
};
